module.exports = __webpack_public_path__ + "bc5bec6967523332b29f409323fc9971.pdf";